import { PriceFormatter } from "../utils/priceFormatter";

export class CurrencyConverter {
    #countriesData;
    #priceFormatter;

    constructor(countriesData) {
        this.#countriesData = countriesData;
        this.#priceFormatter = new PriceFormatter();
    }

    #getExchangeRateInternal(currencyCode) {
        const country = this.#countriesData?.find((c) => c.currencyCode === currencyCode);
        if (!country?.exchangeRate) {
            return 0;
        }
        return country.exchangeRate;
    }

    getExchangeRate = (currencyCode) => {
        return this.#getExchangeRateInternal(currencyCode);
    };

    convertCurrency(price, fromCurrency, toCurrency, roundingBase = 1) {
        if (fromCurrency === toCurrency) {
            if (toCurrency === "THB") {
                return this.#priceFormatter.round(price);
            }
            return roundingBase > 1 ? Math.ceil(price / roundingBase) * roundingBase : price;
        }

        const exchangeRate = this.#getExchangeRateInternal(
            fromCurrency === "THB" ? toCurrency : fromCurrency
        );

        if (!exchangeRate) return 0;

        const converted = fromCurrency === "THB" ? price * exchangeRate : price / exchangeRate;

        if (toCurrency === "THB") {
            return this.#priceFormatter.round(converted);
        }

        if (roundingBase > 1) {
            const rounded = Math.ceil(converted / roundingBase) * roundingBase;
            // If original price is not zero but rounding resulted in zero, return at least roundingBase
            return price === 0 ? 0 : rounded < roundingBase ? roundingBase : rounded;
        }

        return converted;
    }

    convertTHBToMMK = (priceInTHB) => {
        return this.convertCurrency(priceInTHB, "THB", "MMK", 10);
    };

    convertMMKToTHB = (priceInMMK) => {
        return this.convertCurrency(priceInMMK, "MMK", "THB");
    };
}
